(() => {
  if (customElements.get('trh-footer')) return;
  customElements.define('trh-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (this.querySelector('[data-newsletter-submitted]')) {
        const code = document.querySelector('trh-welcome-offer')?.dataset.code;
        try { if (code) localStorage.setItem('trh-welcome:v1:' + code + ':pending-confirmation', String(Date.now())); } catch { /* Storage is optional. */ }
      }
      this.mobile = window.matchMedia('(max-width:699px)');
      this.groups = [...this.querySelectorAll('.trh-footer-group')];
      this.mobileOpen = new Map(this.groups.map(group => [group, group.classList.contains('trh-footer-company')]));
      const resize = () => {
        this.groups.forEach(group => {
          group.open = this.mobile.matches ? this.mobileOpen.get(group) : true;
          const summary = group.querySelector('summary');
          if (this.mobile.matches) {
            summary.removeAttribute('tabindex');
            summary.removeAttribute('aria-disabled');
          } else {
            summary.tabIndex = -1;
            summary.setAttribute('aria-disabled', 'true');
          }
        });
      };
      this.groups.forEach(group => group.addEventListener('toggle', () => {
        if (this.mobile.matches) this.mobileOpen.set(group, group.open);
        else if (!group.open) group.open = true;
      }, options));
      this.mobile.addEventListener('change', resize, options);
      resize();
      const top = this.querySelector('[data-back-to-top]');
      if (top) {
        let scheduled = false;
        const update = () => { top.hidden = window.scrollY < Math.max(600, window.innerHeight); scheduled = false; };
        window.addEventListener('scroll', () => {
          if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
        }, { ...options, passive: true });
        top.addEventListener('click', event => {
          event.preventDefault();
          document.querySelector('#MainContent')?.focus({ preventScroll: true });
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        update();
      }
      this.querySelector('[data-privacy-preferences]')?.addEventListener('click', event => {
        const banner = window.privacyBanner || window.Shopify?.privacyBanner;
        if (typeof banner?.showPreferences !== 'function') return;
        const fallbackUrl = event.currentTarget.href;
        event.preventDefault();
        Promise.resolve(banner.showPreferences()).catch(() => {
          window.location.assign(fallbackUrl);
        });
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();

